// remove messages from chat
// remove helper

export const reducerCloseChat = (state) => ({
  ...state,
  chats: {}
})
